import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPage } from './telemetry';

const hasConsent = () => localStorage.getItem('tilly_consent') === 'granted';

/**
 * Records a pageview on every route change. Consent-gated like the rest of the
 * visitor-facing analytics (the GA4 pageview this replaces was too). A visitor
 * who accepts the banner after landing has already passed the route change, so
 * the current page is recorded when consent is granted as well.
 */
export function RouteTelemetry(): null {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (hasConsent()) recordPage(pathname + search);
  }, [pathname, search]);

  useEffect(() => {
    const onConsent = () => recordPage(window.location.pathname + window.location.search);
    window.addEventListener('consent-granted', onConsent);
    return () => window.removeEventListener('consent-granted', onConsent);
  }, []);

  return null;
}
